const customerName = "SNOOZECOMAU";

export default ({ app }) => {
  console.log("Mazing: plugin.client.js loaded");
  console.log("Mazing: customerName:", customerName);
  const scriptTag = document.createElement("script");
  scriptTag.src = "https://cdn.mazing.link/mzg-in.js";
  scriptTag.type = "text/javascript";
  scriptTag.crossOrigin = "anonymous";
  scriptTag.defer = true;
  document.head.append(scriptTag);

  let currentProduct;
  let initializing = false;
  let currentColor;
  let currentSize;
  let colorClickHandler = null;
  let sizeClickHandler = null;

  // const isMobile = window.matchMedia("(max-width: 800px)").matches;

  const waitForMazingFunction = new Promise(resolve => {
    const interval = 50;
    const checkInterval = setInterval(() => {
      if (typeof window.mazing === "function") {
        clearInterval(checkInterval);
        resolve();
      }
    }, interval);
  });

  const initializeMazing = async () => {
    cleanupMazingButton();

    const lang = navigator.language || navigator.userLanguage;
    const langKey = lang.split("-")[0];

    const threedTranslations = {
      en: "View in 3D",
      de: "In 3D ansehen",
      fr: "Voir en 3D",
      es: "Ver en 3D",
    };

    const arTranslations = {
      en: "View in Room",
      de: "Im Raum anzeigen",
      fr: "Voir dans votre espace",
      es: "Ver en tu espacio",
    };

    await window.mazing({
      customerName,
      buttonConfiguration: {
        customStyle: `
          .pdp__image:not(.pdp-mobile-img) {
             position: relative;
          }

          .mazing-button-container {
            position: absolute;
            bottom: 16px;
            right: 12px;
            z-index: 25;
            padding: 0;
            display: flex;
            margin: 0.75rem 0 0;
          }

          @media (max-width: 1024px) {
            .mazing-button-container {
              bottom: 6px;
            }
          }

          @media (max-width: 800px) {
            .mazing-button-container {
              bottom: unset;
            }
          }

          .mazing-threed-btn,
          .mazing-ar-btn {
            background: #f7f4ef !important;
            border: 1px solid #d8d0c7 !important;
            box-shadow: none !important;
            border-radius: 999px !important;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            min-height: 48px;
            padding: 0 18px;
            position: relative;
            overflow: hidden;
            transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease;
            margin-right: 0px;
          }

          .mazing-threed-btn:hover,
          .mazing-ar-btn:hover {
            background: #efe8de !important;
            border-color: #c9beb1 !important;
            transform: translateY(-1px);
          }

          .mazing-threed-btn:active,
          .mazing-ar-btn:active {
            transform: translateY(0);
          }

          .mazing-threed-btn-text,
          .mazing-ar-btn-text {
            color: #2f2a26 !important;
            font-weight: 600;
            font-size: 14px;
            line-height: 1;
            letter-spacing: 0.01em;
            text-transform: none;
          }

          .mazing-ar-btn-icon,
          .mazing-threed-btn-icon {
            width: 18px !important;
            height: 18px !important;
            margin: 0 !important;
            filter: brightness(0) saturate(100%) invert(14%) sepia(8%) saturate(552%) hue-rotate(355deg) brightness(95%) contrast(88%);
            flex-shrink: 0;
          }

          .mazing-threed-btn::before,
          .mazing-ar-btn::before {
            content: none !important;
          }

          @media (max-width: 750px) {
            .mazing-threed-btn,
            .mazing-ar-btn {
              min-height: 44px;
              padding: 0 16px;
            }

            .mazing-threed-btn-text,
            .mazing-ar-btn-text {
              font-size: 13px;
            }
          }

          .mazing-button-container:has(.mazing-threed-btn[style*="visibility: hidden"]),
          .mazing-button-container:has(.mazing-ar-btn[style*="visibility: hidden"]) {
            padding: 0;
            display: none;
          }
        `,
        placementSelector: getPlacementSelector(),
        threedBtn: {
          enabled: true,
          icon: true,
          customText: threedTranslations[langKey] || threedTranslations.en,
        },
        arBtn: {
          enabled: false,
          icon: true,
          customText: arTranslations[langKey] || arTranslations.en,
        },
      },
      getSKU: getCurrentSKU,
    });

    console.log("Mazing initialized.");
  };

  const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== "").pop();
    const productParts = product.split("?");

    currentProduct = productParts[0].toLowerCase();

    const activeColor = document.querySelector(
      "button.border-black [data-sis-colour]"
    );
    const color = activeColor ? activeColor.dataset.sisColour : currentColor;
    currentColor = color;

    const activeSize = document.querySelector(".active-tile [data-sis-size]");
    const size = activeSize ? activeSize.dataset.sisSize : currentSize;
    currentSize = size;

    const finalSKU = [
      currentProduct,
      color?.toLowerCase().replace(/\s+/g, "-"),
      size?.toLowerCase().replace(/\s+/g, "-"),
    ]
      .filter(Boolean)
      .join("-");

    console.log("Mazing SKU:", finalSKU);

    return finalSKU;
  };

  const getPlacementSelector = () => {
    // On mobile (windowWidth <= 800), PdpImage renders with the extra
    // 'pdp-mobile-img' class. Target it directly so Mazing doesn't inject
    // into the hidden desktop instance that appears first in DOM order.
    if (document.querySelector(".pdp-mobile-img")) return ".pdp-mobile-img";
    return ".pdp__image";
  };

  const cleanupMazingButton = () => {
    document
      .querySelectorAll(".pdp__image .mazing-button-container")
      .forEach(el => el.remove());
  };

  const cleanupMazingPopups = () => {
    const popups = document.querySelectorAll("#mazing-popup-container");
    if (popups.length > 1) {
      popups.forEach((popup, index) => {
        if (index !== popups.length - 1) {
          popup.remove();
        }
      });
    }
  };

  const handleColorClick = e => {
    const colorItem = e.target.closest("[data-sis-colour]");
    if (!colorItem) return;

    // Re-read currentSize fresh from DOM in case it wasn't captured during init
    const activeSizeEl = document.querySelector(".active-tile [data-sis-size]");
    if (activeSizeEl) currentSize = activeSizeEl.dataset.sisSize;

    currentColor = colorItem.dataset.sisColour;

    const refreshSKU = [
      currentProduct,
      currentColor?.toLowerCase().replace(/\s+/g, "-"),
      currentSize?.toLowerCase().replace(/\s+/g, "-"),
    ]
      .filter(Boolean)
      .join("-");

    console.log("Mazing colour changed, refreshSKU:", refreshSKU);

    cleanupMazingPopups();
    setTimeout(() => window.mazingRefreshSKU(refreshSKU, customerName), 100);
  };

  const handleSizeClick = e => {
    const button = e.target.closest("button");
    if (!button) return;

    const sizeItem = button.querySelector("[data-sis-size]");
    if (!sizeItem) return;

    // Re-read currentColor fresh from DOM in case it wasn't captured during init
    const activeColorEl = document.querySelector(
      "button.border-black [data-sis-colour]"
    );
    if (activeColorEl) currentColor = activeColorEl.dataset.sisColour;

    currentSize = sizeItem.dataset.sisSize;

    const refreshSKU = [
      currentProduct,
      currentColor?.toLowerCase().replace(/\s+/g, "-"),
      currentSize?.toLowerCase().replace(/\s+/g, "-"),
    ]
      .filter(Boolean)
      .join("-");

    console.log("Mazing size changed, refreshSKU:", refreshSKU);

    cleanupMazingPopups();
    setTimeout(() => window.mazingRefreshSKU(refreshSKU, customerName), 100);
  };

  const removeClickListeners = () => {
    if (colorClickHandler) {
      document.removeEventListener("click", colorClickHandler);
      colorClickHandler = null;
    }
    if (sizeClickHandler) {
      document.removeEventListener("click", sizeClickHandler);
      sizeClickHandler = null;
    }
  };

  const initializeScript = async () => {
    if (initializing) return;
    initializing = true;

    try {
      await waitForMazingFunction;

      await initializeMazing();

      removeClickListeners();

      colorClickHandler = handleColorClick;
      sizeClickHandler = handleSizeClick;
      document.addEventListener("click", colorClickHandler);
      document.addEventListener("click", sizeClickHandler);

      console.log("Mazing: initialized successfully.");
    } catch (error) {
      console.error("Mazing: initialization failed:", error);
    } finally {
      initializing = false;
    }
  };

  app.router.afterEach((to, from) => {
    const toIsPdp = to.path.includes("/products/");
    const fromIsPdp = from && from.path.includes("/products/");

    if (!toIsPdp && fromIsPdp) {
      removeClickListeners();
      return;
    }

    // Only reinitialize when the path itself changes (i.e. navigating to a
    // different product). Variant switches only update the query string so
    // to.path === from.path — we must not re-initialize in that case because
    // the variant click handlers already call mazingRefreshSKU, and calling
    // initializeMazing() again would inject a duplicate button.
    // const pathChanged = !from || to.path !== from.path;

    if (toIsPdp) {
      setTimeout(initializeScript, 500);
    }
  });

  if (window.location.pathname.includes("/products/")) {
    console.log("Mazing: initializing on PDP");
    setTimeout(initializeScript, 500);
  }
};
